let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8oY8A"), load("iB2zz"), load("ePOyH"), load("eacuJ")]).then(() => parcelRequire('bzo9I'));